module.exports = __webpack_public_path__ + "static/media/icon-odt.87663cfb.svg";